import React from 'react';
import GenericTermsPage from '../components/GenericTermsPage'; // Adjusted path

const LAST_UPDATED_DATE = 'May 2025'; // Updated date

const WEBSITE_TERMS_CONTENT = `
Welcome to codemates.app. By accessing our website, you agree to these Terms of Service.

1. Use of Website
This website is provided for your personal and informational use. You agree not to use the website for any unlawful purpose.

2. Intellectual Property
All content on this website, including text, graphics, logos, and software, is the property of CodeMates Software Limited or its content suppliers and protected by international copyright laws.

3. Disclaimer of Warranties
This website is provided "as is" without any representations or warranties, express or implied. CodeMates Software Limited makes no representations or warranties in relation to this website or the information and materials provided.

4. Limitation of Liability
CodeMates Software Limited will not be liable to you in relation to the contents of, or use of, or otherwise in connection with, this website for any indirect, special or consequential loss.

5. User Content
If you submit any content to our website (e.g., comments, feedback), you grant us a non-exclusive, royalty-free license to use, reproduce, and publish such content. You are responsible for ensuring your content is lawful and does not infringe any third-party rights.

6. Links to Other Websites
Our website may contain links to third-party websites. These links are provided for your convenience only. We have no control over the content of these websites and accept no responsibility for them or for any loss or damage that may arise from your use of them.

7. Modifications to Terms
We reserve the right to revise these Terms of Service at any time. By using this website, you are agreeing to be bound by the then current version of these Terms of Service.

8. Governing Law
Any legal suit, action, or proceeding arising out of, or related to, these Terms or the Site shall be instituted exclusively in the courts of Hong Kong, although we retain the right to bring any suit, action, or proceeding against you for breach of these Terms in your country of residence or any other relevant country. You waive any and all objections to the exercise of jurisdiction over you by such courts and to venue in such courts.

9. Contact Us
If you have any questions about these Terms, please contact us at <a href="mailto:support@codemates.app" style="color:#007bff;text-decoration:none;">support@codemates.app</a>.
`;

function WebsiteTermsPage() {
  return (
    <GenericTermsPage
      appName="CodeMates Website" // Or simply null/empty if no prefix desired
      lastUpdatedDate={LAST_UPDATED_DATE}
      termsContent={WEBSITE_TERMS_CONTENT}
    />
  );
}

export default WebsiteTermsPage; 